import { CurrencyMaskModule } from "ngx-currency-mask";
import { OrderModule } from 'ngx-order-pipe';
import { HttpClientModule } from '@angular/common/http';
import { PregaoService } from './service/pregao/pregao.service';
import { ModalParamComponent } from './layout/admin/modal/modal-parametros/modal-parametros-component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ModalChangePassComponent } from './layout/admin/modal/modal-change-pass/modal-change-pass-component';
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';

import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { MenuItems } from './shared/menu-items/menu-items';
import { BreadcrumbsComponent } from './layout/admin/breadcrumbs/breadcrumbs.component';
import { ToastyModule } from "ng2-toasty";
import { CookieService } from "ngx-cookie-service";
import { AuthGuardService } from "./guards/auth-guard.service";
import { NgxMaskModule } from "ngx-mask";
import { registerLocaleData, CommonModule } from '@angular/common';
import localept from '@angular/common/locales/pt';
import * as moment from 'moment';
import { ModalAlterarSenhaUsuariosComponent } from "./layout/admin/modal/modal-alterar-senha-usuarios/modal-alterar-senha-usuarios-component";
import { SelectModule } from "ng-select";
import { ComponentModule } from './component/component.module';
import { AuthGuardPermissionService } from './guards/auth-guard-permission.service';
import { TelaInicialComponent } from './module/tela-inicial/tela-inicial.component';
import { CURRENCY_MASK_CONFIG } from "ngx-currency-mask/src/currency-mask.config";
import { CustomCurrencyMaskConfig } from "./util/customCurrencyMaskConfig";

registerLocaleData(localept, 'pt');
moment.locale('pt-br');


@NgModule({
    declarations: [
        AppComponent,
        AdminComponent,
        AuthComponent,
        BreadcrumbsComponent,
        ModalChangePassComponent,
        ModalAlterarSenhaUsuariosComponent,
        ModalParamComponent,
        TelaInicialComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        HttpClientModule,
        ToastyModule.forRoot(),
        NgxMaskModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot(),
        SelectModule,
        ComponentModule,
        MatTableModule,
        MatDialogModule,
        OrderModule,
        CommonModule,
        CurrencyMaskModule
    ],
    providers: [
        MenuItems,
        CookieService,
        AuthGuardService,
        AuthGuardPermissionService,
        PregaoService,
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
